import {
  Box,
  InputAdornment,
  TextField,
  Typography,
  useTheme,
} from "@mui/material";

interface NumericInputProps {
  label?: string;
  value: string | number;
  placeholder?: string;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

const NumericInput = ({
  label,
  value,
  onChange,
  placeholder,
}: NumericInputProps) => {
  const theme = useTheme();
  return (
    <Box>
      {label && (
        <Typography
          color={theme.nawy.colors.semantic.text.secondary}
          sx={{
            ...theme.nawy.typography.english.variants.body.xs.regular,
          }}
        >
          {label}
        </Typography>
      )}
      <TextField
        sx={{
          height: "36px",
          borderRadius: theme.nawy.radius.lg,
          border: `1px solid ${theme.nawy.colors.semantic.border.primary}`,
          background: theme.nawy.colors.semantic.layer.primary,
        }}
        slotProps={{
          input: {
            sx: {
              ...theme.nawy.typography.english.variants.body.md.regular,
              height: "36px",
            },
            endAdornment: <InputAdornment position="end">EGP</InputAdornment>,
          },
        }}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
      />
    </Box>
  );
};

export default NumericInput;
